import React from 'react';
import { styles } from './editTdsConfig.style';

const SegmentMap = ({ segments }: { segments: string[] }) => (
	<div className='tag-container'>
		{segments.map((segment: string) => (
			<div key={segment} style={styles.tag}>
				{segment}
			</div>
		))}
	</div>
);

export default SegmentMap;
